import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Link as RouteNavLink } from "react-router-dom";
import MenuBar from "shared/components/MenuBar/MenuBar";
import baseUrl from "config/baseUrl";
import {
  CardBody,
  Container,
  CardTitle,
  CardLink,
  Row,
  Col,
} from "shards-react";
import imgbox from "shared/assets/img/imgbox.png";
import { useTranslation } from "react-i18next";

const axios = require("axios").default;

const StyledTitle = styled(CardTitle)`
  color: #1968bc;
  font-size: 14px;
  margin-top: 15px;
`;
const StyledCardBody = styled(CardBody)`
  padding: 0px;
`;
const StyledCardLink = styled(CardLink)`
  color: #8d8d8d;
  cursor: pointer;
  margin: 0px !important;
  :hover {
    color: #8d8d8d;
  }
`;
const NavTab = styled.div`
  padding: 65px 0
  cursor: pointer;
  display: grid;
  grid-template-columns: repeat( 4, 1fr);
  justify-items: center;
  grid-gap: 20px;
  @media (max-width: 1180px) {
    grid-template-columns: repeat(3, 1fr); 
  }
  @media (max-width: 1000px) {
    grid-template-columns: repeat(2, 1fr); 
  }
  @media (max-width: 900px) {
    grid-template-columns: repeat(1, 1fr); 
  }
  @media (max-width: 600px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;
const NavCard = styled.div`
  margin-bottom: 10px;
  color: ${(props) => props.color};
  background-color: #fff;
  border: none;
  padding: 10px;
  height: 100%;
  border-radius: 0.625rem;
  box-shadow: 0 0.46875rem 2.1875rem rgb(90 97 105 / 10%),
    0 0.9375rem 1.40625rem rgb(90 97 105 / 10%),
    0 0.25rem 0.53125rem rgb(90 97 105 / 12%),
    0 0.125rem 0.1875rem rgb(90 97 105 / 10%);
  :hover {
    background-color: #1968bc !important;
    color: #fff !important;
    .card-title {
      color: #fff !important;
    }
  }
`;
const Image = styled.img`
  vertical-align: middle;
  border-style: none;
  max-width:100%;
  height:auto;
  width: 250px;
  object-fit: cover;
  border-radius: 8px;
`;
const TabImage = styled.div`
  margin-bottom: 10px;
  align-content: ${(props) => props.center};
  justify-content: ${(props) => props.center};
  align-items: ${(props) => props.center};
  display: ${(props) => props.display};
  margin: 0 auto;
  text-align: center;
  width: 100%;
  max-width: 250px;
  margin-bottom: 10px;
  max-height: 250px;
  margin: 0 auto;
  text-align: center;
`;
const IndicatorsList = (props) => {
  const { match } = props;
  const { t, i18n } = useTranslation();
  const [dataTabList, setDataTabList] = useState(null);
  const [contentSettingId, setContentSettingId] = useState(null);
  const [contentSettingName, setContentSettingName] = useState(null);
  const [contentSettingNameEN, setContentSettingNameEN] = useState(null);
  const [contentSubSettingId, setContentSubSettingId] = useState(
    match.params.id
  );
  const [contentSubSettingName, setContentSubSettingName] = useState(null);
  const [contentSubSettingNameEN, setContentSubSettingNameEN] = useState(null);
  useEffect(() => {
    if (contentSubSettingId) {
      var data = JSON.stringify({
        params: {
          contentSubSettingId: contentSubSettingId,
        },
        show: 100,
        page: 1,
        orderBy: "contentSubDetailSettingId",
        orderType: "ASC",
      });

      var config = {
        method: "post",
        url: `${baseUrl}/v1/setting/contentsubdetaillistshow`,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
      axios(config)
        .then((response) => {
          setDataTabList(response.data);
          if (response.data.data.length > 0) {
            setContentSettingId(response.data.data[0].contentSettingId);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [contentSubSettingId]);
  useEffect(() => {
    if (contentSubSettingId) {
      var data = JSON.stringify({
        params: {
          contentSubSettingId: contentSubSettingId,
        },
        show: 5,
        page: 1,
        orderBy: "contentSubSettingId",
        orderType: "ASC",
      });

      var config = {
        method: "post",
        url: `${baseUrl}/v1/setting/contentsublistshow`,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
      axios(config)
        .then((response) => {
          setContentSettingId(response.data.data[0].contentSettingId);
          setContentSettingName(response.data.data[0].contentSettingName);
          setContentSettingNameEN(response.data.data[0].contentSettingNameEN);
          setContentSubSettingName(response.data.data[0].contentSubSettingName);
          setContentSubSettingNameEN(
            response.data.data[0].contentSubSettingNameEN
          );
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, {});
  const menu = [
    {
      path: "/",
      title:
        i18n.language === "th"
          ? contentSettingName
          : contentSettingNameEN || contentSettingName,
    },
    {
      path: "/",
      title:
        i18n.language === "th"
          ? contentSubSettingName
          : contentSubSettingNameEN || contentSubSettingName,
    },
  ];
  return (
    <Container>
      <MenuBar menu={menu} mode="indicators"/>
      <Row className="mt-2">
        {dataTabList != null &&
          dataTabList.data.length > 0 &&
          dataTabList.data.map((item, key) => (
            <Col
              className="mb-4"
              sm="6"
              md="4"
              xl="3"
              key={key}
              tag={RouteNavLink}
              to={`/indicators/detail/${item.indicatorsDatasetSettingId}`}
            >
              <NavCard>
                <TabImage>
                  <Image
                    src={
                      item.contentSubDetailSettingPic
                        ? `${baseUrl}/${item.contentSubDetailSettingPic}`
                        : imgbox
                    }
                    bg={"none"}
                  />
                  {/* ${baseUrl}/${item.contentSubDetailSettingPic} */}
                </TabImage>
                <StyledCardBody>
                  <StyledTitle>
                    {i18n.language === "th"
                      ? item.indicatorsDatasetSettingName
                      : item.indicatorsDatasetSettingNameEN ||
                        item.indicatorsDatasetSettingName}
                  </StyledTitle>
                  <p>
                    {i18n.language === "th"
                      ? item.indicatorsAgencySettingName
                      : item.indicatorsAgencySettingNameEN ||
                        item.indicatorsAgencySettingName}
                  </p>
                </StyledCardBody>
              </NavCard>
            </Col>
          ))}
      </Row>
    </Container>
  );
};
export default IndicatorsList;
